import React from 'react';
import { matchPath } from 'react-router';

import { List } from '@mui/material';
import { $tid } from '@provider-portal/common/utils/testIdConfig';
import NavItem, { NavItemInterface } from 'widgets/NavBar/NavItem';

// tricky logic that we take from our template
// the idea is that it able to render navigation in recursive way
// so we able to have sub-menus

interface RenderNavItemsParams {
  items: NavItemInterface[];
  depth?: number;
  pathname: string;
  disabled: boolean;
}

interface ReduceChildRoutesParams {
  acc: React.ReactNode[];
  item: NavItemInterface;
  depth: number;
  pathname: string;
  disabled: boolean;
}

const navigationItemIdsToTestIdsMapping = {
  dashboard: $tid.components.SideBar.Analytics.DashBoard,
  restaurantWeeklyReport: $tid.components.SideBar.Analytics.WeeklyReport,
  itemReport: $tid.components.SideBar.Analytics.DetailedReports,
  invoicesAndSalesReports: $tid.components.SideBar.Analytics.InvoicesAndSales,
  orderHistory: $tid.components.SideBar.Analytics.OrderHistory,
  'org-summary': $tid.components.SideBar.MenuEditor.OrgSummary,
  'my-menu': $tid.components.SideBar.MenuEditor.MyMenu,
  items: $tid.components.SideBar.MenuEditor.Items,
  modifiers: $tid.components.SideBar.MenuEditor.Modifiers,
  timetables: $tid.components.SideBar.MenuEditor.Timetables,
};

const getTestIdForItemId = (itemId: string): string => {
  if (navigationItemIdsToTestIdsMapping[itemId]) {
    return navigationItemIdsToTestIdsMapping[itemId];
  }

  return '';
};

const reduceChildRoutes = ({
  acc,
  pathname,
  item,
  disabled = false,
  depth = 0,
}: ReduceChildRoutesParams) => {
  const key = item.titleIntlId + depth;

  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false,
    });

    acc.push(
      <NavItem key={key} open={Boolean(open)} titleIntlId={item.titleIntlId} disabled={disabled}>
        {/* eslint-disable-next-line @typescript-eslint/no-use-before-define */}
        {renderNavItems({
          pathname,
          items: item.items,
          disabled,
        })}
      </NavItem>,
    );
  } else {
    acc.push(
      <NavItem
        href={item.href}
        key={key}
        titleIntlId={item.titleIntlId}
        disabled={disabled}
        data-testid={getTestIdForItemId(item.id)}
      />,
    );
  }

  return acc;
};

export const renderNavItems = ({
  items,
  depth = 0,
  pathname,
  disabled = false,
}: RenderNavItemsParams) => {
  return (
    <List sx={{ paddingTop: 1 }}>
      {items
        .filter((item) => !item.hidden)
        .reduce(
          (acc, item) => reduceChildRoutes({ acc, item, depth, pathname, disabled }),
          [] as React.ReactNode[],
        )}
    </List>
  );
};
